import React, { useState } from 'react';
import { FormControl, InputLabel, MenuItem, Select} from '@mui/material/';
import FormHelperText from '@mui/material/FormHelperText';
import {useStyles} from './style';

export default function FormSeleccionar(props) {
    const classes = useStyles();
    const [self] = useState(props.this);
    return (
        <FormControl className={classes.formControl}>
            <InputLabel id={props.name}> {props.label ? props.label : 'Seleccione una opcion'}</InputLabel>
            <Select
                id={props.name}
                name={props.name}
                value={props.value}
                onChange={(event)=>{
                    props.handleChange(event,self)
                }}
                disabled={props.disabled}
            >
            {props.list.map((option,index) => (
                <MenuItem key={index} value={option.id} data-index={index}>
                    {option.name}
                </MenuItem>
            ))}
            </Select>
            {(props.isError) ? <FormHelperText className="Mui-error" id="component-error-text">{props.errorMessages}</FormHelperText> : null }
        </FormControl>
    )
}